import { Link } from '@/components/atoms/Link';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Head from 'next/head';
import React from 'react';

type LinkType = {
  text: string;
  href: string;
  icon?: React.ReactElement;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export interface BreadcrumbProps {
  links: LinkType[];
  renderSchema?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  links,
  renderSchema = true,
}) => {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: links.map((link, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: link.text,
      item: link.href,
    })),
  };
  return (
    <>
      {renderSchema && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(breadcrumbSchema),
            }}
          />
        </Head>
      )}
      <nav className="flex items-center">
        {links.map((link, i) => {
          const isLastLink = i === links.length - 1;
          return (
            <React.Fragment key={i}>
              <div
                className={`flex items-center gap-s rounded-xsmall px-s py-xs ${isLastLink ? '' : 'hover:bg-blue-light'}`}
              >
                {link.icon}
                <Link
                  className={`text-microLight ${isLastLink ? 'cursor-default text-neutral-800' : 'text-blue-medium'}`}
                  href={link.href}
                  onClick={isLastLink ? undefined : link.onClick}
                >
                  {link.text}
                </Link>
              </div>

              {i !== links.length - 1 && (
                <ChevronRightIcon className="mx-xs h-l w-l text-neutral-800" />
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </>
  );
};

export default Breadcrumb;
